import { FC } from "react";

import Logo from "../../../../public/images/New-landing/logo-dark.svg";


type Props = {
  mainText: string;
};

const Header: FC<Props> = ({ mainText }) => {
  return (
    <div>
      <div className="mb-6">
        <Logo width={102} height={27} />
      </div>

      <h3 className="mb-8 md-md-12 text-[24px] text-md-[32px] leading-[140%] text-[#031F47] font-bold">
        {mainText}
      </h3>
    </div>
  );
};

export { Header };
